import { render, staticRenderFns } from "./work-order-details.html?vue&type=template&id=1c4f8659&scoped=true&"
import script from "./work-order-details.js?vue&type=script&lang=js&"
export * from "./work-order-details.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4f8659",
  null
  
)

export default component.exports